import { render, staticRenderFns } from "./CreateAdyenAccount.vue?vue&type=template&id=20ce5d5e"
import script from "./CreateAdyenAccount.vue?vue&type=script&lang=js"
export * from "./CreateAdyenAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports